import styled from 'styled-components';

export default styled.div`
  && {
    .report {
      height: 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0px 40px;
      .tutorial {
        display: flex;
        flex-direction: column;
        .manual {
          width: 667px;
          height: 63px;
          text-align: left;
        }
      }
      .btn-report {
        width: 149px;
        height: 59px;
        background-color: #ff8a00;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        color: white;
      }
    }
    .search {
      padding: 0px 40px;
      display: flex;
      align-items: center;
      .btn-search {
        width: 80px;
        height: 43px;
        background-color: #ff8a00;
        color: white;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        margin-left: 19px;
        margin-right: 15px;
      }
      .btn-clear {
        width: 80px;
        height: 43px;
        background-color: #c4c4c4;
        color: white;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
      }
    }
    .table {
      padding: 15px 40px;
    }
    .pagination {
      padding: 19px 40px;
    }
    .save {
      margin-top: 50px;
      margin-bottom: 95px;
      display: flex;
      justify-content: center;
      .btn-save {
        width: 365px;
        height: 60px;
        text-align: center;
        box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2);
        border-radius: 5px;

        border: none;
        color: white;
      }
    }
    .save-default {
      background-color: #ff8a00;
    }
    .save-ok {
      background-color: #c1e18d;
    }
  }
`;
